import { nextTick } from "vue";
import _ from "lodash";
import { hasProperty } from "@/client/utilities";
export default {
  props: {
    modelValue: {},
    fields: {
      type: Object,
      default: {},
    },
    groups: {
      type: Object,
      default: () => {},
    },
    inputSize: {
      type: [Boolean, String, Number],
      default: false,
    },
    /**
     * Prevent class attr from being automatically set. This causes visual issue when used within FormInput
     */
    class: {
      type: String,
      default: "",
    },
    name: {
      type: [String, Boolean],
      default: false,
    },
    errorMessage: {
      type: [String, Array],
      default: "",
    },
  },
  data: function () {
    return {
      newLocaleAddValue: null,
      //  validationModel: {},
      errorFixed: false,
      addingNewItems: false,
      addingItemsTimeout: null,
      addingItemsTimeoutLength: 600,
      isEnforcingIntegrity: false,
      hasAddError: false,
    };
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    hasError() {
      return this.errorMessage !== "";
    },
    uniqueId() {
      return utilities.getUniqueNumber();
    },
    translatedLocales() {
      if (!this.value || typeof this.value !== "object") {
        return [];
      }

      return Object.keys(this.value);
    },
    allLocales() {
      return Object.values(this.getLocaleObjects());
    },
    hasUntranslatedLocales() {
      let result = false;
      this.allLocales.forEach((availableLocale) => {
        if (!this.translatedLocales.includes(availableLocale.tag)) {
          result = true;
          return false;
        }
      });
      return result;
    },
    untranslatedLocalesList() {
      return this.allLocales
        .map((locale) => {
          return { value: locale.tag, label: locale.labelFull };
        })
        .filter((locale) => !this.translatedLocales.includes(locale.value));
    },
  },
  created() {},
  methods: {
    enforceValueIntegrity() {
      if (this.isEnforcingIntegrity) {
        return;
      }

      this.isEnforcingIntegrity = true;

      let isFieldDeleted = false;

      let newValue = this.value ? this.value : {};

      for (const [index, item] of Object.entries(newValue)) {
        let clean = { ...item };

        for (const field of Object.keys(item)) {
          if (!Object.keys(this.fields).includes(field)) {
            delete clean[field];
            isFieldDeleted = true;
          }
        }
        newValue[index] = clean;
      }

      if (isFieldDeleted) {
        this.value = newValue;
      }

      utilities.inTwoTicks(() => {
        this.isEnforcingIntegrity = false;
      });
    },
    async addRow() {
      if (!this.newLocaleAddValue || this.newLocaleAddValue === "") {
        this.$nextTick(() => {
          this.hasAddError = true;
        });
        return;
      }
      // check rare case where location requested is not available
      let availableNewLocales = Object.values(this.untranslatedLocalesList).map(
        (item) => item.value
      );
      console.log("add row", this.newLocaleAddValue, availableNewLocales);

      if (!availableNewLocales.includes(this.newLocaleAddValue)) {
        this.$s.ui.notification("core.form.translations.selectCorrectValueNotification");
        return false;
      }
      if (this.translatedLocales.includes(this.newLocaleAddValue)) {
        this.$s.ui.notification(
          "core.entity.translations.localeAlreadyTranslatedNotification"
        );
        return false;
      }

      clearTimeout(this.addingItemsTimeout);
      this.addingNewItems = true;
      let row = {};

      for (const [key, field] of Object.entries(this.fields)) {
        row[key] = field.defaultValue || null;
      }

      // if parent has delived us nothing, encofce value integrity
      if (typeof this.value === "undefined") {
        this.value = {};
        // we must wait for the parent to tick, so our change is updated. value becomes {} only on next tick
        await this.$nextTick();
      }

      this.value[this.newLocaleAddValue] = row;
      this.newLocaleAddValue = null;
      utilities.setClientTimeout(() => {
        try {
          this.addingNewItems = false;
        } catch (e) {
          //
        }
      }, this.addingItemsTimeoutLength);

      this.setDefaultValueToAddTranslationField();
    },
    removeRow(index) {
      delete this.value[index];
      if (!this.newLocaleAddValue) {
        this.setDefaultValueToAddTranslationField();
      }
    },
    getItemClean(input) {
      // bug - need to add default empty fields
      let base = {};
      for (const [key, field] of Object.entries(this.fields)) {
        base[key] = field.defaultValue || null;
      }
      let item = Object.assign(base, input);

      if (typeof item._id !== "undefined") {
        delete item._id;
      }

      // filter invalid fields
      let final = {};
      for (const field of Object.keys(item)) {
        if (Object.keys(this.fields).includes(field)) {
          final[field] = item[field];
        }
      }

      return final;
    },
    getLocaleLabel(slug) {
      let location = this.getLocaleObjects()[slug];

      if (!location) {
        return "-";
      }

      return this.getLocaleObjects()[slug].labelFull;
    },
    setDefaultValueToAddTranslationField() {
      if (this.untranslatedLocalesList.length > 0) {
        this.newLocaleAddValue = this.untranslatedLocalesList[0].value;
      }
    },
    getGroupedCleanItem(input) {
      let cleanItem = this.getItemClean(input);
    },
    getGroupedFields() {
      let groups = this.groups;

      let res = {
        free: {
          name: "free",
          component: "div",
          props: {},
        },
        ..._.cloneDeep(groups),
      };

      Object.values(res).forEach((item) => {
        item.fields = {};
        if (!item.props) {
          item.props = {};
        }
      });

      for (const [fieldIndex, field] of Object.entries(this.fields)) {
        if (field.group && utilities.hasOwnProperty(res, field.group)) {
          res[field.group].fields[fieldIndex] = field;
        } else {
          res.free.fields[fieldIndex] = field;
        }
      }

      for (const [groupKey, group] of Object.entries(res)) {
        if (Object.values(group.fields).length === 0) {
          delete res[groupKey];
        }
      }
      return res;
    },
  },
  emits: ["update:modelValue"],
  mounted() {
    this.setDefaultValueToAddTranslationField();
  },
  watch: {
    value: {
      handler: "enforceValueIntegrity",
      deep: true,
      immediate: true,
    },
    newLocaleAddValue() {
      this.hasAddError = false;
    },
    untranslatedLocalesList(newVal) {
      if (!Array.isArray(newVal)) {
        return;
      }
      // prevent rare case of empty select for new translations
      if (!newVal.includes(this.newLocaleAddValue) && newVal.length > 0) {
        this.newLocaleAddValue = newVal[0].value;
      }
    },
  },
};
